export const CONTEXT_SELECTOR_FEATURE_NAME = 'contextSelector';
